import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { frostedSegmentTabsSx } from 'src/common/styles/frostedPanelStyles';
import { AppFileRouterEndpoint } from 'src/interfaces/AppFileRouter';
import useFileManagerStore from 'src/stores/fileManagerStore';

type EndpointFilter = 'all' | AppFileRouterEndpoint;

const ENDPOINT_TABS: EndpointFilter[] = ['all', 'image', 'document', 'trackMap'];

type FileTypeTabsProps = {
  lockedEndpoint?: AppFileRouterEndpoint;
};

const FileTypeTabs = ({ lockedEndpoint }: FileTypeTabsProps) => {
  const { t } = useTranslation();
  const endpoint = useFileManagerStore(state => state.endpoint);
  const setEndpointFilter = useFileManagerStore(state => state.setEndpointFilter);

  const handleChange = (_event: SyntheticEvent, value: EndpointFilter) => {
    if (lockedEndpoint) {
      return;
    }
    setEndpointFilter(value);
  };

  const activeValue = lockedEndpoint ?? endpoint;

  return (
    <Tabs
      value={activeValue}
      onChange={handleChange}
      aria-label={t('system.fileManager.fileType')}
      variant="scrollable"
      scrollButtons="auto"
      sx={theme => ({
        ...(frostedSegmentTabsSx(theme) as object),
        flexShrink: 0,
        px: { xs: 1, sm: 2 },
        mb: 2,
      })}
    >
      {ENDPOINT_TABS.map(tabValue => (
        <Tab
          key={tabValue}
          value={tabValue}
          label={tabValue === 'all' ? t('base.all') : t(`system.fileManager.types.${tabValue}`)}
          disabled={Boolean(lockedEndpoint && tabValue !== lockedEndpoint)}
        />
      ))}
    </Tabs>
  );
};

export default FileTypeTabs;
